<script>
  import FullScreenModal from "@retailer/svelte/Shared/FullScreenModal.svelte";
  import ListBuilder from "@retailer/svelte/ListBuilder/Containers/ListBuilder.svelte";
  export let list;
  export let placeholderProduct;
  export let isVisible;
  export let isMakingApiCall;
  export let search;
  export let productPicker;
  export let newProduct;
  export let svelteCloseCallback;
  export let onProductLineSearch;
  export let onChooseProductSize;
  export let onAddProductLinePlaceholder;
  export let onRemoveProductLinePlaceholder;
  export let onGoBackToProductLineResults;
  export let onAddProductToList;
  export let onRemoveProductFromList;
  export let onProductPickerTabChange;
  export let onAddAnotherProduct;
  export let onCreateNamedPlaceholder;
</script>

<FullScreenModal {isVisible} {svelteCloseCallback}>
  <ListBuilder
    {list}
    {placeholderProduct}
    {isVisible}
    {isMakingApiCall}
    {search}
    {productPicker}
    {newProduct}
    {onProductLineSearch}
    {onChooseProductSize}
    {onAddProductLinePlaceholder}
    {onRemoveProductLinePlaceholder}
    {onGoBackToProductLineResults}
    {onAddProductToList}
    {onRemoveProductFromList}
    {onProductPickerTabChange}
    {onAddAnotherProduct}
    {onCreateNamedPlaceholder}
  />
</FullScreenModal>
